export const GENERIC_STATE_DESCRIPTION =
  "We have put together a template to get you started on letting your \
  employee know their services are no longer required.";

export const GENERIC_STATE_TITLE = "Not sure where to start?";
